import { getCsrfTokenMock as CsrfTokenHandles } from 'ap-openapi';
import { GraphQLHandler, HttpHandler } from 'msw';
import { handlers as AiAgentSettingHandlers } from './ap-agents-setting';
import { handlers as ApCounterpartyHandlers } from './ap-counterparty';
import { handlers as ApCurrencyRateHandlers } from './ap-currency-rates';
import { handlers as GeneralInputOptionsHandlers } from './ap-general-input-options';
import { handlers as InvoiceTransactionGeneralInputsHandlers } from './ap-invoice-transaction-general-inputs';
import { handlers as ApOfficeForeignCurrencySetting } from './ap-office-foreign-currency-setting';
import { handlers as ApOfficeMemberReceivedInvoiceNotificationSettingHandlers } from './ap-office-member-received-invoice-notification-setting';
import { handlers as ApOfficeMemberReportNotificationSettingHandlers } from './ap-office-member-report-notification-setting';
import { handlers as ApPayeeHandlers } from './ap-payee';
import { handlers as ApPayeeContactInformPdfTemplateHandlers } from './ap-payee-contact-inform-pdf-template';
import { handlers as ApPayeeContactInformPdfTemplateDefaultHandlers } from './ap-payee-contact-inform-pdf-template-default';
import { handlers as ApPayeeGetMacroHandlers } from './ap-payee-get-macro';
import { handlers as ApPayeesInvitationsMailsHandlers } from './ap-payees-invitations-mails';
import { handlers as ApPayeesInvitationsPdfsHandlers } from './ap-payees-invitations-pdfs';
import { handlers as ApPrefecturesHandlers } from './ap-prefectures';
import { handlers as ApStamplessContractHandlers } from './ap-stampless-contract';
import { handlers as ApprovingInvoiceReportsHandlers } from './approving-invoice-reports';
import { handlers as BankBranchesHandlers } from './bank-branches';
import { handlers as BanksHandlers } from './banks';
import { handlers as BusinessDocumentHandlers } from './business-document';
import { handlers as CRItemsHandlers } from './cr-items';
import { handlers as CRSubItemsHandlers } from './cr-sub-items';
import { handlers as CurrencyUnitsHandlers } from './currency-units';
import { handlers as DeptsHandlers } from './depts';
import { handlers as EDocPlanHandlers } from './e-doc-plan';
import { handlers as ExItemHandlers } from './ex-items';
import { handlers as ExItemsByDeptHandlers } from './ex-items-by-dept';
import { handlers as ExcisesHandlers } from './excises';
import { handlers as ExportFilesHandlers } from './export-files';
import { handlers as GeneralReportsHandlers } from './general-reports';
import { handlers as GraphQLHandlers } from './graphql/login';
import { handlers as NotificationSetting } from './graphql/notification-setting';
import { handlers as ImportExportHistoryHandlers } from './import-export-histories';
import { handlers as InvoiceHandlers } from './invoice';
import { handlers as InvoiceReportHandlers } from './invoice-report';
import { handlers as InvoiceReportsHandlers } from './invoice-reports';
import { handlers as MfFileHandlers } from './mfFile';
import { handlers as OcrInvoiceInferences } from './ocr-invoice-inferences';
import { handlers as officeMemberPositionDeptsHandlers } from './office-member-position-depts';
import { handlers as OpenFeatureHandlers } from './open-feature';
import { handlers as ProjectCodeHandlers } from './project-codes';
import { handlers as ReportHandlers } from './reports';
import { handlers as SearchApPayeesHandlers } from './search-ap-payees';
import { handlers as SpecialExceptionsHandlers } from './special-exception-statuses';
import { handlers as TpmInvoiceHandlers } from './tpm-invoice';

export const mockHandlers: (HttpHandler | GraphQLHandler)[] = [
  ...InvoiceHandlers,
  ...MfFileHandlers,
  ...ApPayeeHandlers,
  ...InvoiceReportHandlers,
  ...InvoiceReportsHandlers,
  ...BusinessDocumentHandlers,
  ...TpmInvoiceHandlers,
  ...GeneralReportsHandlers,
  ...ApStamplessContractHandlers,
  ...NotificationSetting,
  ...OpenFeatureHandlers,
  ...GraphQLHandlers,
  ...ApCounterpartyHandlers,
  ...ExItemHandlers,
  ...DeptsHandlers,
  ...CRItemsHandlers,
  ...CRSubItemsHandlers,
  ...CurrencyUnitsHandlers,
  ...ExItemsByDeptHandlers,
  ...CsrfTokenHandles(),
  ...ApCurrencyRateHandlers,
  ...ProjectCodeHandlers,
  ...ExcisesHandlers,
  ...ApOfficeForeignCurrencySetting,
  ...ApOfficeMemberReceivedInvoiceNotificationSettingHandlers,
  ...ApOfficeMemberReportNotificationSettingHandlers,
  ...ReportHandlers,
  ...SpecialExceptionsHandlers,
  ...BanksHandlers,
  ...BankBranchesHandlers,
  ...officeMemberPositionDeptsHandlers,
  ...EDocPlanHandlers,
  ...ApPayeeContactInformPdfTemplateDefaultHandlers,
  ...ApPayeeContactInformPdfTemplateHandlers,
  ...SearchApPayeesHandlers,
  ...ApPayeesInvitationsPdfsHandlers,
  ...ApPayeesInvitationsMailsHandlers,
  ...ApPayeeGetMacroHandlers,
  ...ExportFilesHandlers,
  ...OcrInvoiceInferences,
  ...ApprovingInvoiceReportsHandlers,
  ...InvoiceTransactionGeneralInputsHandlers,
  ...GeneralInputOptionsHandlers,
  ...ApPrefecturesHandlers,
  ...AiAgentSettingHandlers,
  ...ImportExportHistoryHandlers,
];
